import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { canAccessService } from "../utils/UserAuth";

/* eslint-disable react/prop-types */
export const PrivateRoute = ({ service }) => {
	const location = useLocation();

	return canAccessService(service) ? (
		<Outlet />
	) : (
		<Navigate to='/unauthorized' state={{ from: location }} replace={true} />
	);
};

export default PrivateRoute;
